import { render, staticRenderFns } from "./sopPage.vue?vue&type=template&id=9930bb5e&scoped=true&"
import script from "./sopPage.vue?vue&type=script&lang=js&"
export * from "./sopPage.vue?vue&type=script&lang=js&"
import style0 from "./sopPage.vue?vue&type=style&index=0&id=9930bb5e&lang=less&scoped=true&"
import style1 from "./sopPage.vue?vue&type=style&index=1&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9930bb5e",
  null
  
)

export default component.exports